module.exports = __webpack_public_path__ + "static/UserAgreement-eb8cc73ce3ef2276e6a623341f867d12.pdf";